import { render, staticRenderFns } from "./AvatarDropdown.vue?vue&type=template&id=4c936209&scoped=true"
import script from "./AvatarDropdown.vue?vue&type=script&lang=js"
export * from "./AvatarDropdown.vue?vue&type=script&lang=js"
import style0 from "./AvatarDropdown.vue?vue&type=style&index=0&id=4c936209&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c936209",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c936209')) {
      api.createRecord('4c936209', component.options)
    } else {
      api.reload('4c936209', component.options)
    }
    module.hot.accept("./AvatarDropdown.vue?vue&type=template&id=4c936209&scoped=true", function () {
      api.rerender('4c936209', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalHeader/AvatarDropdown.vue"
export default component.exports